import { Routes, Route } from "react-router-dom";
import { RegistrationCompletion, ValidateUser } from "../../containers";
import { Layout } from "../../components";

const RegistrationCompletionRoutes = () => {
  return (
    <Routes>
      <Route path="/validate-user" element={<ValidateUser />} />
      <Route element={<Layout />}>
        <Route path="/" element={<RegistrationCompletion />} />
        <Route path="*" element={<RegistrationCompletion />} />
      </Route>
    </Routes>
  );
};

export default RegistrationCompletionRoutes;
